<template>
  <div class="hris-profile-link-candidates">
    <v-card
      variant="outlined"
      rounded="lg"
      class="pa-3"
    >
      <template v-if="candidates.length === 0">
        <p class="text-body-3 text-textLight">
          No {{ hrisDisplayName }} profiles found. Try updating the job code or title to find a match.
        </p>
      </template>

      <template v-else>
        <p class="text-body-3 text-textLight mb-2">
          {{ matchCountCopy }}
        </p>
        <v-btn
          variant="outlined"
          color="primary"
          rounded="lg"
          size="small"
          :disabled="rescorePending || readOnly"
          @click="setModal({ field: 'hrisProfileLink', value: true })"
        >
          Link to {{ hrisDisplayName }} profile
        </v-btn>
      </template>
    </v-card>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useModals } from '@/stores/modals/modals';
import { useAppAuthData } from '@/stores/app/authData';

const { hrisDisplayName } = storeToRefs(useAppAuthData());

const { jobProfile, rescorePending, readOnly } = storeToRefs(useCurrentJobProfile());
const { setModal } = useModals();

const candidates = computed(() => jobProfile.value?.hris_matching ?? []);

const matchCountCopy = computed(() => {
  const count = candidates.value.length;
  const label = count === 1 ? 'profile' : 'profiles';

  return `${count} ${hrisDisplayName.value} ${label} ${count === 1 ? 'match' : 'matches'} found.`;
});
</script>

<style lang="less" scoped>
.hris-profile-link-candidates .v-card {
  border-color: @stroke-default;
}
</style>
